import React from "react";
import { useNavigate, useLocation } from "react-router";
import { TabStrip, TabStripTab } from "@progress/kendo-react-layout";
import {GridContainerFlex} from "../../GridFlex/GridContainerFlex/GridContainerFlex.jsx";
import {GridItemFlex} from "../../GridFlex/GridItemFlex/GridItemFlex.jsx";
import "./TopNav.css"


export const TopNav = ({navLinks = [], ...otherProps}) => {
    const navigate = useNavigate();
    const location = useLocation();

    // Find selected tab index based on current pathname
    const selected = navLinks.findIndex(tab => location.pathname.endsWith(tab.path));

    const onSelect = (e) => {
        const selectedPath = navLinks[e.selected].path;
        if (!location.pathname.endsWith(selectedPath)) {
            navigate(selectedPath);
        }
    };

    return (
        <GridContainerFlex justifyContent={"center"}>
            <GridItemFlex xs={12}>
                <TabStrip selected={selected ?? null} onSelect={onSelect} className={"top-nav"}>
                    {navLinks.map((tab) => (
                        <TabStripTab key={tab.path} title={tab.title} />
                    ))}
                </TabStrip>
            </GridItemFlex>
        </GridContainerFlex>
    );
};
